<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :icon="icon"
    sizeClass='modal-med'
    :submitting="submitting"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="textEntryForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="warningTitle">
        <NotificationBarTitle><span v-html="warningTitle" /></NotificationBarTitle>
        <NotificationBarItem v-for="item of warningItems" :key="item">{{item}}</NotificationBarItem>
      </NotificationBar>
      <p v-if="notes">{{notes}}</p>
      <FormRow :label="textLabel">
        <FormInputTextArea ref="textEntryArea" v-model="text" :placeholder="placeholder" :field="textField" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'PurchaseOrderActionDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    title: String,
    icon: String,
    textLabel: String,
    placeholder: String,
    textField: String,
    notes: String,
    warningTitle: String,
    warningItems: Array,
    submitTitle: String,
    submitPromise: Function
  },
  data() {
    return {
      submitting: false,
      text: '',
      textEntryForm: {}
    }
  },
  mounted() {
    
  },
  computed: {
  },
  methods: {
    show(params) {
      this.textEntryForm = {}
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {       
      this.submitting = true
      this.textEntryForm = {}

      this.submitPromise({ text: this.text })
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.textEntryForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>